const strSizeNum = (strSize) => {
  switch (strSize.toUpperCase()) {
    case 'XXS':
      return 1
    case 'XS':
      return 2
    case 'S':
      return 3

    case 'M':
      return 4

    case 'L':
      return 5

    case 'XL':
      return 6

    case 'XXL':
      return 7

    case 'XXXL':
      return 8

    default:
      return -1
  }
}

export const numSortAsc = (a, b) => {
  if (a < b) {
    return -1
  }

  if (a > b) {
    return 1
  }
  return 0
}

export const numSortDesc = (a, b) => {
  if (a < b) {
    return 1
  }

  if (a > b) {
    return -1
  }
  return 0
}

export const strSortAsc = (a, b) => {
  return a.localeCompare(b)
}

export const strSortDesc = (a, b) => {
  return a.localeCompare(b) * -1
}

export const sizeSortDesc = (a, b) => {
  const intA = parseInt(a, 10)
  const intB = parseInt(b, 10)

  if (Number.isNaN(intA) && Number.isNaN(intB)) {
    const scoreA = strSizeNum(a)
    const scoreB = strSizeNum(b)

    if (scoreA === scoreB && scoreA === -1) return strSortAsc(a, b)

    return scoreB - scoreA
  }

  if (Number.isNaN(intA)) return -1

  if (Number.isNaN(intB)) return 1

  return intB - intA
}

export const sizeSortAsc = (a, b) => {
  return sizeSortDesc(a, b) * -1
}

export const dateSortAsc = (a, b) => {
  const dateA = new Date(a)
  const dateB = new Date(b)

  return dateA - dateB
}
